import { rand, randRecentDate, randText } from '@ngneat/falso';

import { MilestonesConst } from '../shipment/milestones';

import { Status } from '../base';

export class MockStatus extends Status {
   constructor() {
      super({
         code: rand( MilestonesConst() ).code,
         status: rand( MilestonesConst() ).label,
         date: randRecentDate({ days: 10 }).toString(),
         event: rand( MilestonesConst() ).label,
         reason: randText(),
      });
   }
}
